import React from "react";

const KEEPALIVE_INTERVAL_MS = 10 * 60 * 1000;

const useSessionKeepalive = (isPresenting, onReload) => {
  React.useEffect(() => {
    if (!isPresenting) return;
    const id = setInterval(() => {
      onReload();
    }, KEEPALIVE_INTERVAL_MS);
    return () => clearInterval(id);
  }, [isPresenting, onReload]);
};

export default useSessionKeepalive;
